import { axios } from "@/lib/axios";

import { TAppointmentRequestStatus } from "../../types";
import {
  IAPIGetMuqabalas,
  IAPIGetMuqabala,
  IAPIPatchCancelReportMuqabala,
} from "../../types/interfaces/api/muqabalas";

export const getAppointmentRequests = ({
  status,
  limit,
  page,
}: {
  status?: TAppointmentRequestStatus;
  limit?: number;
  page?: number;
} = {}): Promise<IAPIGetMuqabalas> => {
  return axios.get(`/muqabala/appointment-requests`, {
    params: {
      status,
      limit,
      page,
    },
  });
};

export const getAppointmentRequest = (
  appointmentSlotId: string
): Promise<IAPIGetMuqabala> => {
  return axios.get(
    `/muqabala/appointment-slots/${appointmentSlotId}/appointment-requests`
  );
};

export const cancelReportMuqabala = ({
  id,
  appointmentSlotId,
  reason,
  action,
}: {
  id: string;
  appointmentSlotId: string;
  reason: string;
  action: "REPORTED" | "CANCELLED";
}): Promise<IAPIPatchCancelReportMuqabala> => {
  return axios.patch(`/muqabala/appointment-requests/${id}/report-or-cancel`, {
    appointmentSlotId,
    reason,
    action,
  });
};
